import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts";
import { ROUTES } from "@/consts";
import { DashboardTab } from "@/types";
import NotAuthorized from "./NotAuthorized";

/**
 * Without a `tab`, any logged in admin can open the route.
 */
export const ProtectedRoute = ({ tab }: { tab?: DashboardTab }) => {
	const {
		state: { token, user },
	} = useAuth();
	if (!token) {
		return <Navigate to={ROUTES.Login} />;
	}

	if (!tab || user?.permissions.includes(tab)) {
		return <Outlet />;
	}
	return <NotAuthorized />;
};
